const App = ({children}) => {
    return (
        <div>
            {children}
        </div>
    )
}

export default App


/*import Component from 'inferno-component'

import Header from './common/Header'

export default class App extends Component {

    render() {
        return (
            <div>
                <Header/>
            </div>
        )
    }

}*/



// WEBPACK FOOTER //
// ./src/App.js